import {Extension} from 'tiptap'
import {sentenceCase} from 'sentence-case'

export default class Caser extends Extension {
  get name() {
    return 'caser'
  }

  commands() {
    return ({type}) => (state, dispatch) => {
      const {tr} = state
      const {empty, $from, $to} = state.selection
      const content = state.selection.content().content
      let transformText

      switch (type) {
        case 'lower':
          transformText = (t) => t.toLowerCase()
          break
        case 'upper':
          transformText = (t) => t.toUpperCase()
          break
        case 'sentence':
          transformText = (t) => sentenceCase(t)
          break
      }

      if (!empty && $from.sameParent($to) && $from.parent.inlineContent) {
        const contentNode = content.content[0]
        let transaction = tr
        contentNode.descendants((node, pos) => {
          if (node.isText) {
            const text = node.text
            const insertFrom = $from.pos + pos
            const insertTo = insertFrom + text.length
            transaction.insertText(transformText(text), insertFrom, insertTo)
          }
        })
        dispatch(transaction)
      } else if (!empty) {
        let transaction = tr
        let cursorPoint = $from.pos
        content.descendants((contentNode) => {
          contentNode.descendants((node, pos) => {
            if (node.isText) {
              const text = node.text
              const insertFrom = cursorPoint + pos
              const insertTo = insertFrom + text.length
              transaction.insertText(transformText(text), insertFrom, insertTo)
            }
          })
          cursorPoint = cursorPoint + contentNode.nodeSize
          // we already iterate across child nodes so no need to do it again
          return false
        })
        dispatch(transaction)
      }
    }
  }
}
